export const hasContactPerson = ({ context }) => {
    return Boolean(context.contactName && context.contactEmail);
};
//# sourceMappingURL=client.js.map